import React, { FC } from 'react';

import { Avatar, Box, HStack, Stack, Text } from '@chakra-ui/react';
import map from 'lodash/map';
import { customTheme } from 'theme';

interface Props {
  references: Record<string, any>[];
}

export const AllReferences: FC<Props> = props => {
  const { references } = props;
  return (
    <Stack spacing={6}>
      {map(references, (o, index) => {
        const domain = new URL(o.url).hostname.replace(/^www\./, '');
        const faviconUrl = `https://www.google.com/s2/favicons?sz=64&domain=${domain}`;
        const url = o.url.replace(/^https?:\/\//, '');

        return (
          <Box
            onClick={() => window.open(o?.url, '_blank')}
            key={index + '-reference'}
            cursor="pointer"
          >
            <Stack spacing={2}>
              <HStack>
                <Box whiteSpace="nowrap">{index + 1}.</Box>
                <HStack align="center" w="full">
                  <Box pt={1}>
                    <Avatar src={faviconUrl} size="sm" />
                  </Box>
                  <Stack spacing={0} fontSize="13px" w="full">
                    <Text>{domain}</Text>
                    <Box w="40%">
                      <Text
                        color={customTheme.colors.gray['250']}
                        w="full"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                      >
                        {url}
                      </Text>
                    </Box>
                  </Stack>
                </HStack>
              </HStack>

              <Stack spacing={0} w="full">
                <Box pl={6} fontSize="17px" w="80%">
                  <Text
                    w="full"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                  >
                    {o?.title}
                  </Text>
                </Box>
                <Box pl={6} color={customTheme.colors.gray['300']}>
                  <Text
                    w="full"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    fontSize="15px"
                    noOfLines={2}
                  >
                    {o?.content}
                  </Text>
                </Box>
              </Stack>
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
};
